<div class="reason">
  <div class="reason-wrap">
    <div class="reason-content">
      <h2
        [innerHTML]="'REASON.TITLE' | translate"
        class="reason-header text-center"
      ></h2>
      <div class="container">
        <div class="row">
          <div class="reason-block text-center col-xs-12 col-sm-12 col-lg-4">
            <div class="reason-icon">
              <img
                alt="icon"
                src="/assets/images/landing/icons/icon-Illustr-speed.png"
              />
            </div>
            <div class="reason-inner">
              <h3 class="reason-subtitle">
                {{ 'REASON.STEP1.LABEL' | translate }}
              </h3>
              <p class="reason-description">
                {{ 'REASON.STEP1.INFO' | translate }}
              </p>
            </div>
          </div>
          <div class="reason-block text-center col-xs-12 col-sm-12 col-lg-4">
            <div class="reason-icon">
              <img
                alt="icon"
                src="/assets/images/landing/icons/icon-Illustr-credit.png"
              />
            </div>
            <div class="reason-inner">
              <h3 class="reason-subtitle">
                {{ 'REASON.STEP2.LABEL' | translate }}
              </h3>
              <p class="reason-description">
                {{ 'REASON.STEP2.INFO' | translate }}
              </p>
            </div>
          </div>
          <div class="reason-block text-center col-xs-12 col-sm-12 col-lg-4">
            <div class="reason-icon">
              <img
                alt="icon"
                src="/assets/images/landing/icons/icon-Illustr-safe.png"
              />
            </div>
            <div class="reason-inner">
              <h3 class="reason-subtitle">
                {{ 'REASON.STEP3.LABEL' | translate }}
              </h3>
              <p class="reason-description">
                {{ 'REASON.STEP3.INFO' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
